// extracted by mini-css-extract-plugin
module.exports = {"clickableNoun":"StandaloneNoun_clickableNoun__15g6a"};